import { assertUnreachable } from 'cadenza/utils/custom-error';

import i18n from './enrichment-type.properties';

// Order matters
const ENRICHMENT_TYPES = [
  'StructuredGeocodingEnrichment',
  'UnstructuredGeocodingEnrichment',
  'IpGeocodingEnrichment',
  'ReverseGeocodingEnrichment',
  'MeasuresFromSpatialIntersectionEnrichment',
  'AnalyticsExtensionEnrichment',
  'IsochronesEnrichment',
] as const;

export type EnrichmentType = (typeof ENRICHMENT_TYPES)[number];

export const EnrichmentType = {
  values: ENRICHMENT_TYPES as readonly EnrichmentType[],
  i18n: (type: EnrichmentType) => i18n(`<${type}>`),
};

const GEOCODING_ENRICHMENT_TYPES = [
  'IpGeocodingEnrichment',
  'ReverseGeocodingEnrichment',
  'StructuredGeocodingEnrichment',
  'UnstructuredGeocodingEnrichment',
] as const satisfies EnrichmentType[];

type GeocodingEnrichmentType = (typeof GEOCODING_ENRICHMENT_TYPES)[number];

export function isGeocodingEnrichment(value: EnrichmentType): value is GeocodingEnrichmentType {
  return GEOCODING_ENRICHMENT_TYPES.includes(value as GeocodingEnrichmentType);
}

export function getGeocodingType(enrichmentType: GeocodingEnrichmentType) {
  switch (enrichmentType) {
    case 'StructuredGeocodingEnrichment':
    case 'UnstructuredGeocodingEnrichment':
      return 'address';
    case 'IpGeocodingEnrichment':
      return 'ip';
    case 'ReverseGeocodingEnrichment':
      return 'reverse';
    default:
      assertUnreachable(enrichmentType);
  }
}

export function compareEnrichmentType(a: EnrichmentType, b: EnrichmentType) {
  return ENRICHMENT_TYPES.indexOf(a) - ENRICHMENT_TYPES.indexOf(b);
}
